export default "__VITE_ASSET__DIqRKWAx__"